import React from "react";
import "../../styles/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div class="footer">
      <div class="footericon">
        <div>
          <a href="https://www.facebook.com/share/16gTkLiZqt/">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>
        <div>
          <a href="https://www.instagram.com/makkalsinthanaiperavai?igsh=MTh4OXpsYzFidGczZQ==">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
        <div>
          <a href="https://youtube.com/@makkalsinthanaiperavai?feature=shared">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        </div>
      </div>
      <div>
        <p className="footp">
          &copy; த.ஸ்டாலின் குணசேகரன். All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
